var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.rows),function(row){return _c('div',{staticClass:"grid__tr"},_vm._l((row.cells),function(cell){return _c('div',{staticClass:"grid__cell",style:([_vm.style, cell.style])},[_vm._v(_vm._s(_vm.getText_(cell)))])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }